<template>
    <NuxtLayout name="malt-base-layout" class="payment-page-layout">
        <div class="payment-main">
            <slot />
        </div>
    </NuxtLayout>
</template>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .payment-page-layout {
        &__background-shape {
            position: fixed;
            bottom: 0;
            right: 0;
            z-index: -1;

            @include mq.screen_sm {
                display: none;
            }
        }
    }
</style>
